import { render, staticRenderFns } from "./StrategyInfo.vue?vue&type=template&id=4b2ace56&scoped=true"
import script from "./StrategyInfo.vue?vue&type=script&lang=js"
export * from "./StrategyInfo.vue?vue&type=script&lang=js"
import style0 from "./StrategyInfo.vue?vue&type=style&index=0&id=4b2ace56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2ace56",
  null
  
)

export default component.exports